import React,{ useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { addProductsToCart , emptyCart } from "../../store/actions/ProductsActions";
import Header from "./templates/header";
import LeftBar from "./templates/left_bar";
import { Toaster } from "./ViewTransactions";
import ApiService from "../../services/api.service";
import { productReducer } from "../../store/reducers/ProductReducer";
import Loader from '../common/Loader'
import {currencyFormatter, getMaskedPhone} from '../common/Utils'
import { toTitleCase, totalTransaction, totalTrans } from './summary'
import BreadCrumbs from "../common/BreadCrumbs";
import { filterByProductType } from "../../utils";
import { ToastContainer } from "react-toastify";

function SelectProducts(props) {
  const {wallet} = useParams()
  const navigation = useNavigate()
  const cartProduct =  useSelector((state) => {
    return state.cart;
  });
  const farmer = useSelector((state) => { return state.farmer; });
  const walletinfo = useSelector((state) => { try{return JSON.parse(state.wallet_info);} catch(e){return {}}  });
  const [selectedProduct, setSelectedProducts] = useState(cartProduct[`${farmer.idNumber}_${walletinfo.walletReferenceCode}`] !== undefined ? cartProduct[`${farmer.idNumber}_${walletinfo.walletReferenceCode}`] : []);
  const dispatch = useDispatch();

  const products = useSelector((state) => {
      return filterByProductType(state.products, state.service_selector) ;
  });

  const location = useLocation();
  const [errorsQuantity, setErrorsQuantity] = useState({})
  const [errorsPrice, setErrorsPrice] = useState({})
  const [loader, showLoader] = useState(false);
  const [farmer_id, setFarmerId] = useState("");
  // let walletinfo = JSON.parse(walletInfo);
  const [balance_err, setBalanceErr] = useState();
  const[steps, setSteps] = useState([{ 'title': 'Products', 'name':'products', 'path': '/select-products', 'current': true }])


  useEffect(() => {
    if (location.state !== undefined && location.state !== null) {
      setFarmerId(location.state.famerid)
  }
  }, [])

   const itemSelector = function (item){

    let data = {...item,
      quantity: 1, price: item.unitPrice
    }
      setSelectedProducts([...selectedProduct, data])
    // dispatch(addProductsToCart({...cartProduct, [`${farmer_id}_${walletinfo.walletReferenceCode}`]: [...selectedProduct, data] }))
   }

  const removeItem = function (item) {
    let data = selectedProduct.filter((val) => (val.serviceCode !== item.serviceCode))
    setSelectedProducts(data)
    let error = errorsQuantity;
      delete error[item.serviceName]
        setErrorsQuantity({...error});
    //  dispatch(addProductsToCart({...cartProduct, [`${farmer_id}_${walletinfo.walletReferenceCode}`]:data}))
  }

  const handleQuantityChange = (index, key, value) => {
    
    if (key === "quantity") {
    let data = [...selectedProduct]
    if(value>=0){
      data[index] = {
      ...selectedProduct[index],[key]:value
      }
    }
      const keyName = data[index].serviceName
      if (value <= 0 || Number.parseInt(value) === NaN) {
        
        setErrorsQuantity({ ...errorsQuantity, [keyName]: value })
       
      }
      else if(errorsQuantity[keyName] !== undefined && value > 0) {
        let error = errorsQuantity;
        delete error[keyName]
        setErrorsQuantity({...error});
        
      }
      setSelectedProducts(data);
      // dispatch(addProductsToCart({...cartProduct, [`${farmer_id}_${walletinfo.walletReferenceCode}`]:data}))
    }
    if (key === "price" && Number(selectedProduct[index].unitPrice) >= value) {
      let data = [...selectedProduct]
      const keyName = data[index].serviceName
      if(value>=0)
      {
        data[index] = {
        ...selectedProduct[index],[key]:value
        }
      }
      if (value <= 0 || Number.parseInt(value) === NaN) {
        setErrorsPrice({ ...errorsPrice, [keyName]: value })
        
      }
      else if(errorsPrice[keyName] !== undefined && value > 0) {
        let data = errorsPrice;
        delete data[keyName];
        setErrorsPrice(data);
        console.log(errorsPrice);
      }
      setSelectedProducts(data);
      // dispatch(addProductsToCart({...cartProduct, [`${farmer_id}_${walletinfo.walletReferenceCode}`]:data}))
    }
    }
    
  const handleChangeQuantity = (index, key, value) => {
      
        if (key === "quantity") {
        let data = [...selectedProduct]
        if(value>=0){
          data[index] = {
          ...selectedProduct[index],[key]:value
          }
        }
          const keyName = data[index].serviceName
          if (value <= 0 || Number.parseInt(value) === NaN) {
            setErrorsQuantity({ ...errorsQuantity, [keyName]: value })
          }
          else if(errorsQuantity[keyName] !== undefined && value > 0) {
            let error = errorsQuantity;
            delete error[keyName]
            setErrorsQuantity({...error}); 
          }
          setSelectedProducts(data);
        }
        if (key === "price" && Number(value) / Number(selectedProduct[index].quantity) <= Number(selectedProduct[index].unitPrice)) {
          let data = [...selectedProduct]
          const keyName = data[index].serviceName
          if(value>=0)
          {
            data[index] = {
            ...selectedProduct[index],[key]:value
            }
          }
          if (value <= 0 || Number.parseInt(value) === NaN) {
            setErrorsPrice({ ...errorsPrice, [keyName]: value })
            
          }
          else if(errorsPrice[keyName] !== undefined && value > 0) {
            let data = errorsPrice;
            delete data[keyName];
            setErrorsPrice(data);
            console.log(errorsPrice);
          }
          setSelectedProducts(data);
        } else {
            Toaster('error',  `Amount exceeds unit price limit of KES ${currencyFormatter(selectedProduct[index].unitPrice)}` );
        }
      }

  const proceedCheckout = (e) => {
    e.preventDefault();
    if (selectedProduct.length === 0) {
        setBalanceErr("The cart is empty")
        return
    }

    if (Object.values(errorsQuantity).length > 0) {
      setBalanceErr("You may have an invalid data in your quantity inputs kindly check and try again")
      return
    }

    if (rawTotal(selectedProduct) < 100) {
      //setBalanceErr("Minimum total amount should be KES 100.00")
      return
    }





    if (Object.values(errorsPrice).length > 0) {
      setBalanceErr("You may have an invalid data in your price inputs kindly check and try again")
      return
    }

    if (walletinfo.AvailableAmount !== undefined && walletinfo.AvailableAmount < totalTrans(selectedProduct)) {
      setBalanceErr("Insufficient Wallet Balance")
      return
    }
    dispatch(addProductsToCart({...cartProduct, [`${farmer.idNumber}_${walletinfo.walletReferenceCode}`]:selectedProduct}))
    navigation("/summary", { state: { farmerID:farmer_id} });
}

    return (
        <div className="home_landing">
            <Header/>
            <div className="home_app">
                <LeftBar />
                <div className="home_data_template_preset">
                    <Loader loader={loader} />
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                    {/* Same as */}
                    <ToastContainer />
                    <div className="select-dashboard" id="cover">
                        <BreadCrumbs steps={steps}></BreadCrumbs>
                        <div className="select-products-title">
                            <h3>Select Products</h3>
                            <h6 className="summary_wrapper_heading" style={{fontSize: 'small', fontStyle: 'normal'}}>
                                <span>{walletinfo.wallet_name ? toTitleCase(walletinfo.wallet_name) : " "} Wallet </span>
                                <span style={{fontWeight: 'normal'}}>Balance </span>
                                Kes {walletinfo.AvailableAmount ? currencyFormatter(walletinfo.AvailableAmount) : '0.00'}
                                <br></br><span className='error_label'> {balance_err ? balance_err : " "}  </span>
                            </h6>
                        </div>
                    </div>
                    <div className="cards">
                        <div className="card-wrapper  floated-left">
                            <div className="card-header">
                                <div className="select-products-subtitle">
                                    <h3>Products</h3>
                                </div>
                            </div>

                            <div className="card-body products-list-table">
                                <table className="products-table">
                                    <thead className="products-table-head">
                                    <th width="10" className=""> Product Name</th>
                                    <th width="100" className="td-float-right">Price</th>
                                    <th width="50" className="td-float-right"></th>
                                    </thead>
                                    <tbody>
                                    {products.length > 0 && products.map((item, i) => (
                                        <tr key={i}>
                                            <td key={i}>{item.serviceName}</td>
                                            <td className="td-float-right">{currencyFormatter(item.unitPrice)}</td>
                                            <td className="td-float-right">
                                                {selectedProduct.filter((val) => val.serviceName === item.serviceName).length === 0 &&
                                                    <div className="add-item-icon">
                                                        <svg onClick={() => {
                                                            itemSelector(item)
                                                        }} id="icon-add_circle_outline" width="20" height="20"
                                                             viewBox="0 0 24 24">
                                                            <path fill="green"
                                                                  d="M12 20.016q3.281 0 5.648-2.367t2.367-5.648-2.367-5.648-5.648-2.367-5.648 2.367-2.367 5.648 2.367 5.648 5.648 2.367zM12 2.016q4.125 0 7.055 2.93t2.93 7.055-2.93 7.055-7.055 2.93-7.055-2.93-2.93-7.055 2.93-7.055 7.055-2.93zM12.984 6.984v4.031h4.031v1.969h-4.031v4.031h-1.969v-4.031h-4.031v-1.969h4.031v-4.031h1.969z"></path>
                                                        </svg>
                                                    </div>}
                                            </td>
                                        </tr>))
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="card-wrapper  floated-right">
                            <div className="card-header">
                                <div className="select-products-subtitle">
                                    <h3>Selected Products</h3>
                                </div>
                            </div>

                            <div
                                className={`card-body selected-products-table  product-selection${selectedProduct.length === 0 ? '-no-data' : ''}`}>
                                {selectedProduct.length > 0 ?
                                    <table className="products-table">
                                        <thead className="products-table-head">
                                        <th width="50">Product Name</th>
                                        <th width="80" className="td-float-middle">Qty</th>
                                        <th width="80" className="td-float-right">Price</th>
                                        <th width="50" className="td-float-right">Total</th>
                                        <th width="50" className="td-float-right">Deduction</th>
                                        <th width="50" className="td-float-right"></th>
                                        </thead>
                                        <tbody>
                                        {selectedProduct.map((item, i) => (
                                            <tr key={i}>
                                                <td>{item.serviceName}</td>
                                                <td className="td-float-middle">
                                                    <input onChange={(e) => {
                                                        handleQuantityChange(i, "quantity", e.target.value)
                                                    }}
                                                           className={`input-quantity ${(item.quantity <= 0 || !item.quantity || errorsQuantity[i] !== undefined) ? 'error-input' : ""}`}
                                                           value={item.quantity >= 0 ? Number.parseInt(item.quantity) : item.quantity}
                                                           type="number"/>

                                                </td>

                                                <td className="td-float-right">{currencyFormatter(Number.parseFloat(item.unitPrice)) } Kes</td>

                                                <td className="td-float-right">{currencyFormatter(item.unitPrice * item.quantity)} Kes</td>
                                                <td className="td-float-right">
                                                    <input
                                                        className={`input-quantity ${(item.price <= 0 || !item.price || errorsPrice[i] !== undefined) ? 'error-input' : ""}`}
                                                        step='1.0' onChange={(e) => {
                                                            handleChangeQuantity(i, "price", e.target.value)
                                                    }}
                                                    type="text"
                                                inputmode="numeric"
                                              />

                                                </td>
                                                <td className="td-float-right">
                                                    <div className="add-item-icon" onClick={() => removeItem(item)}>
                                                        <svg id="icon-remove_circle_outline" width="20" height="20"
                                                             viewBox="0 0 24 24">
                                                            <path fill='red'
                                                                  d="M12 20.016q3.281 0 5.648-2.367t2.367-5.648-2.367-5.648-5.648-2.367-5.648 2.367-2.367 5.648 2.367 5.648 5.648 2.367zM12 2.016q4.125 0 7.055 2.93t2.93 7.055-2.93 7.055-7.055 2.93-7.055-2.93-2.93-7.055 2.93-7.055 7.055-2.93zM6.984 11.016h10.031v1.969h-10.031v-1.969z"></path>
                                                        </svg>
                                                    </div>

                                                </td>
                                            </tr>

                                        ))
                                        }
                                        </tbody>
                                    </table>
                                    :
                                    <p className="no-data">Please select a product from the products panel first</p>
                                }
                            </div>
                        </div>
                    </div>


                    <div className="card-wrapper-full-width">
                        <div className="buttons-wrapper" id="cover">
                            <input onClick={(e) => {
                                e.preventDefault();
                                navigation("/", {
                                    state: {
                                        farmerid: farmer_id,
                                        walletId: walletinfo.walletReferenceCode
                                    }
                                });
                            }} type="button" className="select-products-button cursor-pointer input-back" value="Back" />
                            

                            <input onClick={proceedCheckout} type="button"
                                
                                   className={`select-products-button primary-btn cursor-pointer ${selectedProduct.length <= 0 ? 'input-place-order-inactive' : 'input-place-order-active'}`}
                                   value={`Order ${getDeductions(selectedProduct)}`}/>
                        </div>
                    </div>

                    <form className="verify_wrapper_form">
                        <div className="verify_wrapper_form_container flex-box">
                {
                  selectedProduct.length > 0 ?
                    rawTotal(selectedProduct) >= 100 ? (
                      <label htmlFor="farmer_id" className="verify_wrapper_form_label text-advice">
                        You will receive {getDeductions(selectedProduct)} from the subsidy program. If this does not cover the total cost of the purchase ensure you get the balance from the customer.
                      </label>
                    ) :
                      (
                        <div className="verify_wrapper_form_container flex-box">
                          <label htmlFor="farmer_id" className="verify_wrapper_form_label error_label invalid_id form-validate"> Minimum Total Amount should be Ksh 100.00 </label>
                        </div>
                      )

                    : null

                }
                        </div>
                    </form>

                </div>
            </div>
        </div>
    );
  }

export const getTotal = (values) => {
    let total = 0
    for (let i =0; i< values.length;i++ ){
      total += (Number(values[i].price) * Number(values[i].quantity))
    }
    return `${currencyFormatter(total)} Kes`
}

export const getDeductions = (values) => {
    let total = 0
    for (let i =0; i< values.length;i++ ){
        total += (Number(values[i].price))
    }
    return `${currencyFormatter(total)} Kes`
}

export const rawTotal = (values) => {
  let total = 0
  for (let i =0; i< values.length;i++ ){
      total += (Number(values[i].price))
  }
  return total
}

  export default SelectProducts;
